import React, { useState, useEffect, useMemo, useContext } from 'react';
import { message, Col, Row, Select, Carousel, Divider, Checkbox } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { AppContext } from '@utils/AppContext';
import styles from './index.module.scss'
import { GenerateContext } from '@utils/GenerateContext';
import API from '@api/api'

const ShoesFilterSelection = (props) => {
    const [shoesType, setShoesType] = useState([]);
    const [shoesTypeOpts, setShoesTypeOpts] = useState([]);
    const [shoesposeOpts, setShoesPoseOpts] = useState([]);
    const [sex, setSex] = useState([]);
    const [age, setAge] = useState([]);
    const [pose, setPose] = useState([]);

    useEffect(() => {
        setShoesType([...props.filterValue?.shoesType || []])
        setPose([...props.filterValue?.pose || []])
        setSex([...props.filterValue?.sex || []])
        setAge([...props.filterValue?.age || []])
    }, [props.filterValue])

    const optFactory = (opt, placeholder) => {
        return {
            mode: "multiple",
            allowClear: true,
            showSearch: false,
            style: { width: '100%'},
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }

    const sexOpts = [{
        value: '女',
        label: '女',
    }, {
        value: '男',
        label: '男',
    }]

    const ageOpts = [{
        value: '成年',
        label: '成年',
    }, {
        value: '儿童',
        label: '儿童',
    }]


    const handleChange2 = (value, key) => {
        switch (key) {
            case 1:
                props.onChange({ shoesType: [...value] })
                break;
            case 2:
                props.onChange({ pose: [...value] })
                break;
            case 3:
                props.onChange({ sex: [...value] })
                break;
            case 4:
                props.onChange({ age: [...value] })
                break;
        }
    }

    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.ModelFilterSelect_tag}>{label}</span>
    }

    const shoesCategoryList = (type) => { 
        API.shoesCategoryList({
            category: type,
            resourceType: 'shoestryon',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            let shoesList = res.data.map(item => ({label: item.display, value: item.value}))
            if(type == 'shoesType') {
                setShoesTypeOpts(shoesList)
            } else if(type == 'poseType') {
                setShoesPoseOpts(shoesList)
            }
        }).catch(err => {
            message.error(err.message)
        }).finally(() => {
            console.log('finally')
        })
    }

    useEffect(() => {
        shoesCategoryList('shoesType')
        shoesCategoryList('poseType')
    }, [])

    return (
        <Row className={styles.ModelFilterSelect} style={{ maxWidth: '800px' }} gutter={5}>
            {
                !props.showLabel &&
                <>
                    <Col span={8}>
                        {props.showLabel && <label htmlFor="modal-skin">品类</label>}
                        <Select id='modal-skin' {...optFactory(shoesTypeOpts, '品类')} value={shoesType} onChange={v => handleChange2(v, 1)} tagRender={tagRender} />
                    </Col>
                    <Col span={8}>
                        {props.showLabel && <label htmlFor="modal-skin">姿势</label>}
                        <Select id='modal-skin' {...optFactory(shoesposeOpts, '姿势')} value={pose} onChange={v => handleChange2(v, 2)} tagRender={tagRender} />
                    </Col>
                    <Col span={8}>
                        {props.showLabel && <label htmlFor="modal-sex">性别</label>}
                        <Select id='modal-sex' {...optFactory(sexOpts, '性别')} value={sex} onChange={v => handleChange2(v, 3)} tagRender={tagRender} />
                    </Col>
                    {/* <Col span={6}>
                        {props.showLabel && <label htmlFor="modal-age">年龄</label>}
                        <Select id='modal-age' {...optFactory(ageOpts, '年龄')} value={age} onChange={v => handleChange2(v, 4)} tagRender={tagRender} />
                    </Col> */}
                </>
            }
        </Row>
    )
}

export default ShoesFilterSelection